import { useViewport } from "./useViewport";

export const useIsMediumScreen = () => {
  const { width } = useViewport();
  const IsMediumScreen = 600 < width && width < 1050;

  return IsMediumScreen;
};